import "./scss/shiptimize.scss";
import "./css/leaflet.css";

import WooCommerce from "./js/shiptimize-woo-commerce.js";
import ShiptimizeWidget from "./js/shiptimize-widget";

/**
 * Class Shiptimize depends on jQuery.
 * Check if we are meant to append a map
 *
 * Platform dependent functions marked with   * @platformDependent
 */
class Shiptimize {
  constructor(ajax_url) {
    this.markers = []; //pickup {lat, lng}
    this.isMapLoaded = false;
    this.gmaps_key =
      typeof shiptimize_maps_key == "undefined" ? "" : shiptimize_maps_key;
    this.openMapMarkerIcons = {};
    this.ajax_url = ajax_url; // platform dependent

    // ✅ Track if scripts are preloading
    this.scriptsPreloaded = false;
    this.addressPreGeocoded = false;

    this.platform = new WooCommerce(this.ajax_url);

    this.platform.isCheckout();
    this.init();
  }

  init() {
    this.shiptimizeWidget = new ShiptimizeWidget({
      host: "https://shiptimize.me",
      address: this.platform.getShippingData().Address,
      labels: {},
      mapParentContainer: "body",
      buttonParentContainer: "body",
      buttonClass: "",
      ajax_url: this.ajax_url,
      carrierId: this.platform.getShippingData().CarrierId,
      onPointSelected: () => {},
      gmapskey:
        typeof shiptimize_maps_key == "undefined" ? "" : shiptimize_maps_key,
    });
    this.shiptimizeWidget.init();

    // ✅ Preload map resources in the background
    this.preloadMapResources();
  }

  /**
   * ✅ NEW: Preload map scripts and geocode address in background
   */
  preloadMapResources() {
    setTimeout(() => {
      // ✅ 1. Preload map scripts
      if (this.shiptimizeWidget.mapinterface && !this.scriptsPreloaded) {
        this.scriptsPreloaded = true;

        if (jQuery("#sw").length === 0) {
          this.shiptimizeWidget.addMapHtml();
        }
      }
    }, 2000);
  }
  /**
   * ✅ NEW: Pre-fetch pickup points in background
   */
  preFetchPickupPoints() {
    // Only if we have carrier ID and geocoded address
    if (
      !this.shiptimizeWidget.carrier_id ||
      !this.shiptimizeWidget.options.address.Lat
    ) {
      return;
    }

    const req = {
      Address: this.shiptimizeWidget.options.address,
      CarrierId: this.shiptimizeWidget.carrier_id,
      action: "shiptimize_pickup_locations",
    };

    jQuery
      .getJSON(this.ajax_url, req, (data) => {
        if (data && data.Point && data.Point.length > 0) {
          // ✅ Cache the results
          const cacheKey = this.shiptimizeWidget.hashLatLng({
            lat: this.shiptimizeWidget.options.address.Lat,
            lng: this.shiptimizeWidget.options.address.Long,
          });

          this.shiptimizeWidget.cacheResults[cacheKey] = data;
        }
      })
      .fail(() => {
        console.log("⚠️ Pre-fetch failed (not critical)");
      });
  }

  getPickupLocations(evt) {
    const carrierId =
      parseInt(jQuery("#shipping_carrier_id").val()) ||
      (window.ShiptimizePickupManager &&
        window.ShiptimizePickupManager.carrier_id);
    if (carrierId) {
      this.shiptimizeWidget.carrier_id = carrierId;
      this.shiptimizeWidget.setCarrierId &&
        this.shiptimizeWidget.setCarrierId(carrierId);
    }
    // ✅ Remove any stale loaders before opening
    jQuery(".shiptimize-loader-btn").stop(true, true).remove();
    this.shiptimizeWidget.openMap(); // openMap() handles its own loader
  }
}

jQuery(function () {
  if (typeof woocommerce_params != "undefined") {
    window.shiptimize = new Shiptimize(woocommerce_params.ajax_url);
  }
});
